import { SOFTWARE_BLACK_MNG } from '@/api/apiModules'

export default {
  viewType: 'form',
  module: SOFTWARE_BLACK_MNG,
  params: null,
  view: {
    title: '创建黑名单',
    labelPosition: 'right',
    labelWidth: '150px',
    content: [
      {
        $id: 'blackContent',
        $type: 'input',
        label: '黑名单',
        rules: [
          {
            notEmpty: '黑名单'
          },
          'textMedium'
        ]
      },
      {
        $id: 'reason',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '加入黑名单原因',
        rules: ['textMedium']
      }
    ]
  }
}
